import * as React from 'react'
import { Plus } from './Plus'
import { BaseIcon } from './'

export const Close = (props: React.ComponentProps<typeof BaseIcon>) => (
  <Plus transform={'rotate(45)'} {...props} />
)
